import { Link, useParams } from 'react-router-dom';
import { LmsAssignmentResponse } from '../lms/LmsAssignmentResponse';
import { StudyShell } from './StudyShell';

/** Personal-plan tasks use LMS authorization, including their scheduled opening time. */
export function IndividualLearningPlanTaskPage() {
  const { assignmentId = '' } = useParams<{ assignmentId: string }>();
  return (
    <StudyShell>
      <Link className="btn-pill-ghost inline-flex" to="/learn/study">
        Back to Study
      </Link>
      <LmsAssignmentResponse assignmentId={assignmentId} />
    </StudyShell>
  );
}
